import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@voicenter-team/voicenter-ui-plus/style.css'
import setupVoicenterTheme from '@voicenter-team/voicenter-ui-plus/theme'
import { loadTextFont } from '@voicenter-team/voicenter-ui-plus/font'
import '@voicenter-team/voicenter-ui-plus/base.css'
import '@/assets/css/icon-vc.css'
import '@/assets/scss/main.scss'
import PortalVue from 'portal-vue'
import VueDraggableResizable from 'vue-draggable-resizable'
import variables from '@/variables.json'

import dashboardPlugin from './plugins/dashboardPlugin'
import echartsPlugin from './plugins/echartsPlugin'
import storageLoggerPlugin from './plugins/storageLoggerPlugin'

import env from '@/env'

async function bootstrap () {
    loadTextFont()
    await setupVoicenterTheme({
        type: 'customJson',
        config: variables,
    })

    const app = createApp(App)

    app.use(router)
    app.use(i18n)
    app.use(ElementPlus)
    app.use(PortalVue)
    app.use(dashboardPlugin)
    app.use(echartsPlugin)
    app.use(storageLoggerPlugin)
    app.component('VueDraggableResizable', VueDraggableResizable)

    app.config.globalProperties.$isDev = env.VITE_APP_API_URL.includes('dev')

    app.mount('#app')
}

bootstrap()
